import type { Rotina } from "~/types/pagesMenu";

export const nomesRotinasPCE = {
	DEVOLVER_MERCADORIA_PICKING: "B3A1 — Devolver Mercadoria ao Picking",
} as const;

export type RotinasPCE = typeof nomesRotinasPCE[keyof typeof nomesRotinasPCE];

/** Rotinas do grupo B3A — PCE. */
export const rotinasPCE: Rotina[] = [
	{
		categoria: "PCE",
		label: nomesRotinasPCE.DEVOLVER_MERCADORIA_PICKING,
		nome: "B3A1DevolverMercadoriaaoPicking1",
		rotina: "pce/devolverMercadoriaPicking",
		tela: "B3A1",
		disponivel: true,
	},
];
